/**
 * Created by Administrador on 12/12/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('customerCorporateService', customerCorporateService);

    customerCorporateService.$inject = ['$http', 'CONFIG', 'messageService'];


    function customerCorporateService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/customerCorporates';
        var service = {
            getCustomerCorporates: getCustomerCorporates,
            getParents: getParents,
            getCustomerCorporate: getCustomerCorporate,
            saveCustomerCorporate: saveCustomerCorporate,
            updateCustomerCorporate: updateCustomerCorporate,
            deleteCustomerCorporate: deleteCustomerCorporate
        };

        return service;

        function getCustomerCorporates(page, size, detailed){
            detailed = (detailed != undefined) ? true  : false;
            return $http.get(urlBase + '?page=' + page + '&size=' + size+"&detailed=" + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getParents(){
            return $http.get(urlBase + '/parents')
                .then(function(response){
                    return (response.data._embedded)? response.data._embedded.customerCorporates : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getCustomerCorporate(customerCorporateId){
            return $http.get(urlBase + "/" + customerCorporateId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('customerCorporates');
                });
        }

        function saveCustomerCorporate(customerCorporate){
            return $http.post(urlBase, customerCorporate)
                .then(function(response){
                    messageService.register('customerCorporates');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('customerCorporates');
                });
        }

        function updateCustomerCorporate(customerCorporate, customerCorporateId){
            return $http.put(urlBase + "/" + customerCorporateId, customerCorporate)
                .then(function(response){
                    messageService.registerUpdate('customerCorporates');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('customerCorporates')
                });
        }

        function deleteCustomerCorporate(customerCorporateId){
            return $http.delete(urlBase + "/" + customerCorporateId)
                .then(function(response){
                    messageService.registerDelete('customerCorporates');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('customerCorporates');
                });
        }
    }
})();
